// extracted by mini-css-extract-plugin
export default {"download":"Download_download__k0ZMi","content":"Download_content__T9MJt"};